import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Et } from 'src/app/interfaces/et';
import { Vehiculo } from 'src/app/interfaces/vehiculo';
import { EtService } from 'src/app/service/et.service';
import { SrService } from 'src/app/service/sr.service';
import { VehiculoService } from 'src/app/service/vehiculo.service';

@Component({
  selector: 'app-et-form',
  templateUrl: './et-form.component.html',
  styleUrls: ['./et-form.component.css']
})
export class EtFormComponent implements OnInit {
  et:Et;
  vehiculos?:Vehiculo[];
  public id =0;
  constructor(private vehiculoService:VehiculoService,private srService:SrService,private etService:EtService, private dialogRef: MatDialogRef<EtFormComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    this.et={
      id_sr:0,
      id_vehiculo:1,
      id_personal:1,
      id_estado:5,
      motivo:""
    };

    this.vehiculos?.push({
        id:0,
        marca:"",
        modelo:"",
        ano:0,
        patente:"",
        detalle:"",
        estado:true
      });
    // this.vehiculos={
    //   marca:"",
    //   modelo:"",
    //   ano:0,
    //   patente:"",
    //   detalle:"",
    //   estado:true
    // }
    console.log('el data '+ data);
    if(data.id_sr===undefined){
      this.etService.getById(data.id).subscribe((element:Et) =>{

        this.et=element;
        // console.log(element);

        });
    }else{
      console.log(data.id_sr+ 'es el id_sr');
      this.et.id_sr=data.id_sr;
    }
    this.CargarInfo();


   }

   private CargarInfo(){
    console.log('cargando el slect');
    this.vehiculoService.getVehiculos().subscribe((data:Vehiculo[]) =>{
      console.log('vehiculo traidos');
      console.log(data);
      this.vehiculos=data;
    });
    console.log(this.vehiculos);
   }
  ngOnInit(): void {

  }
  ver(){
    console.log(this.et);
  }

  tipoEnvio(estado:number){
    this.et.id_estado=estado;
  }
  enviar(){
    this.srService.postNewEstado(this.et.id_sr,3).then(data =>{
      console.log(data)

        this.etService.postNuevaEt(this.et).then(id => {
          console.log(id);
          this.id=id;
          this.dialogRef.close(data);
        });

    });
  }
}
